"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadSignedPanel = UploadSignedPanel;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
/** Zgodny z limitem serwera (MAX_UPLOAD_BYTES = 10 MB); serwer i tak sprawdza to sam. */
const MAX_UPLOAD_MB = 10;
/**
 * „Wgraj podpisany”: ręczne wgranie PDF-a podpisanego poza PS (na przykład w programie Szafir).
 * Serwer sprawdza podpis i certyfikat, zapisuje plik w folderze pisma i oddaje nazwisko z certyfikatu
 * albo powód odmowy po polsku. Ten sam panel stoi w oknie podpisu (jako alternatywa) i we własnym oknie.
 */
function UploadSignedPanel({ source, onUploaded, }) {
    const [state, setState] = (0, react_1.useState)({ kind: "idle" });
    const inputRef = (0, react_1.useRef)(null);
    async function handleFile(file) {
        if (!file)
            return;
        if (!/\.pdf$/i.test(file.name) && file.type !== "application/pdf") {
            setState({ kind: "error", message: "To nie jest plik PDF. Wybierz podpisany plik z rozszerzeniem .pdf." });
            return;
        }
        if (file.size > MAX_UPLOAD_MB * 1024 * 1024) {
            setState({ kind: "error", message: `Plik jest za duży (limit ${MAX_UPLOAD_MB} MB).` });
            return;
        }
        setState({ kind: "uploading", fileName: file.name });
        try {
            const result = await source.uploadSigned(file);
            source.onChanged();
            setState({ kind: "done", result });
            onUploaded?.(result);
        }
        catch (error) {
            setState({
                kind: "error",
                message: error instanceof Error ? error.message : "Nie udało się wgrać pliku. Spróbuj ponownie.",
            });
        }
        finally {
            if (inputRef.current)
                inputRef.current.value = "";
        }
    }
    const busy = state.kind === "uploading";
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("p", { className: "mb-2" },
            "Masz PDF podpisany kwalifikowanym podpisem w innym programie (na przyk\u0142ad w Szafirze)? Wybierz go tutaj. Po wybraniu pliku sprawdz\u0119 podpis i zapisz\u0119 go ",
            source.texts.inFolder,
            " na Dysku Google."),
        react_1.default.createElement("p", { className: "small text-muted" },
            "Nie por\u00F3wnuj\u0119 tre\u015Bci pliku z dokumentem w PS \u2014 wybierz w\u0142a\u015Bciwy plik. Przyjmuj\u0119 tylko PDF z wa\u017Cnym podpisem kwalifikowanym (do ",
            MAX_UPLOAD_MB,
            " MB)."),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: `signed-upload-${source.key}`, className: "mb-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "visually-hidden" }, "Podpisany plik PDF"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { ref: inputRef, type: "file", accept: ".pdf,application/pdf", disabled: busy, onChange: (event) => handleFile(event.target.files?.[0]) })),
        state.kind === "uploading" && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info", className: "d-flex align-items-center", style: { gap: "12px" } },
            react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", role: "status", "aria-hidden": "true" }),
            react_1.default.createElement("span", null,
                react_1.default.createElement("strong", null,
                    "Sprawdzam podpis i zapisuj\u0119 plik \u201E",
                    state.fileName,
                    "\u201D na Dysku\u2026"),
                react_1.default.createElement("br", null),
                "To trwa zwykle kilka sekund. Nic nie klikaj, poczekaj na wynik."))),
        state.kind === "error" && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" },
            react_1.default.createElement("strong", null, "Nie przyj\u0105\u0142em tego pliku."),
            react_1.default.createElement("br", null),
            state.message,
            react_1.default.createElement("br", null),
            react_1.default.createElement("span", { className: "small" }, "Wybierz inny plik albo podpisz ten ponownie i wgraj jeszcze raz."))),
        state.kind === "done" && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCircleCheck, className: "me-2" }),
            react_1.default.createElement("strong", null,
                "Przyj\u0119to. Plik podpisa\u0142(a): ",
                state.result.signerName,
                "."),
            react_1.default.createElement("br", null),
            "Zapisa\u0142em go ",
            source.texts.inFolder,
            " jako",
            " ",
            react_1.default.createElement("a", { href: state.result.signedUrl, target: "_blank", rel: "noopener noreferrer" }, state.result.signedName),
            ".",
            state.result.certChangedWarning && (react_1.default.createElement("div", { className: "mt-2" },
                react_1.default.createElement("strong", null, "Uwaga:"),
                " ten certyfikat r\u00F3\u017Cni si\u0119 od tego, kt\u00F3rym ta osoba podpisywa\u0142a w PS wcze\u015Bniej. Je\u015Bli karta by\u0142a wymieniana, to normalne; je\u015Bli nie, sprawd\u017A, kto podpisa\u0142."))))));
}
